import type { MainActions } from '@confluence/content-types-header';

import { ContentTypesActionsService } from './content-types-actions-service';

export const contentMainActionsService = new ContentTypesActionsService<MainActions>();
